import {Injector, NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {AppRoutingModule} from './app-routing.module';
import {AppComponent} from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NavService} from './core/services/nav.service';
import {FlexLayoutModule} from "@angular/flex-layout";
import {MenuListItemComponent} from './core/menu-list-item/menu-list-item.component';
import {ProductService} from './configuration/services/product.service';
import {SharedModule} from "./shared/shared.module";
import {CoreModule} from "./core/core.module";
import {HttpClient, HttpClientModule} from "@angular/common/http";
import {
  AccessControllerService,
  BASE_PATH as FALCON_BASE_PATH,
  ConfigApiControllerService,
  FalconApiModule
} from 'falcon-api';
import {environment} from '../environments/environment';
import {LoggerModule, NGXLogger, NgxLoggerLevel} from "ngx-logger";
import {BASE_PATH as LEIA_BASE_PATH, LeiaApiModule} from "leia-api";
import {LogsModule} from "./logs/logs.module";
import {BrandModule} from "./configuration/brand/brand.module";
import {ConfigurationModule} from "./configuration/configuration.module";
import {CreateApplicationComponent} from './application/create/create-application.component';
import {UtilitiesService} from "./core/services/utilities.service";
// OKTA
import {OktaAuth} from '@okta/okta-auth-js';
import {OktaAuthModule, OKTA_CONFIG} from '@okta/okta-angular';
import {AuthService} from "./core/auth/auth.service";

import {SkyhopperApiModule, BASE_PATH as BASE_PATH_SKYHOPPER} from "skyhopper-api";
import { SuccessDialogComponent } from './shared/components/success-dialog/success-dialog.component';
import { CookieService } from 'ngx-cookie-service';
import { TokenService } from './core/services/token.service';
import {SocureDialogComponent} from "./shared/components/socure-dialog/socure-dialog.component";
import {
  TellUsAboutYourselfComponent
} from "./application/create/tell-us-about-yourself/tell-us-about-yourself.component";
import {EmploymentDetailsComponent} from "./application/create/employment-details/employment-details.component";
import {ValidationComponent} from "./application/create/validation/validation.component";
import {GooglePlaceModule} from "ngx-google-places-autocomplete";
import {SessionStorageService} from "./shared/models/session-storage.service";
import {BsaProfileComponent} from "./application/create/bsa-profile/bsa-profile.component";
import {FormsModule} from "@angular/forms";
import {STEPPER_GLOBAL_OPTIONS} from "@angular/cdk/stepper";
import { IConfig, NgxMaskModule } from "ngx-mask";

export let AppInjector: Injector;
const maskConfig: Partial<IConfig> = { };
const oktaConfig = {
  issuer: environment.okta_issuer,
  clientId: environment.okta_client_id,
  redirectUri: window.location.origin + '/login/callback',
  postLogoutRedirectUri: environment.okta_signout_path,
  scopes: ['openid', 'offline_access', 'profile'],
};

@NgModule({
  declarations: [
    AppComponent,
    MenuListItemComponent,
    CreateApplicationComponent,
    SuccessDialogComponent,
    SocureDialogComponent,
    TellUsAboutYourselfComponent,
    EmploymentDetailsComponent,
    ValidationComponent,
    BsaProfileComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FlexLayoutModule,
    HttpClientModule,
    AppRoutingModule,
    CoreModule,
    SharedModule,
    LogsModule,
    ConfigurationModule,
    BrandModule,
    LeiaApiModule,
    FalconApiModule,
    SkyhopperApiModule,
    OktaAuthModule,
    GooglePlaceModule,
    FormsModule,
    NgxMaskModule.forRoot(maskConfig),
    LoggerModule.forRoot({
      level: NgxLoggerLevel.DEBUG,
      serverLogLevel: NgxLoggerLevel.DEBUG,
    }),

  ],exports: [TellUsAboutYourselfComponent, EmploymentDetailsComponent, BsaProfileComponent],
  providers: [NavService, ProductService, HttpClient, ConfigApiControllerService, UtilitiesService, AccessControllerService, AuthService, CookieService, TokenService, SessionStorageService,
    {provide: LEIA_BASE_PATH, useValue: environment.api_base_url_leia},
    {provide: FALCON_BASE_PATH, useValue: environment.api_base_url_falcon},
    {
      provide: OKTA_CONFIG,
      // useValue: oktaAuth,
      useFactory: () => {
        const oktaAuth = new OktaAuth(oktaConfig);
        return {oktaAuth};
      },
    },
    {provide: BASE_PATH_SKYHOPPER, useValue: environment.api_base_url_skyhopper},
    {
      provide: STEPPER_GLOBAL_OPTIONS,
      useValue: { displayDefaultIndicatorType: false }
    }
    //{provide: APP_INITIALIZER, useFactory: initializeApp, multi: true, deps: [CookieService, TokenService]},
    //{ provide: HTTP_INTERCEPTORS, useClass: BearerTokenInterceptor, multi: true }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {

  constructor(private logger: NGXLogger,
              private injector: Injector) {
    AppInjector = this.injector;
    this.logger.info(' Falcon Base Api :' + environment.api_base_url_falcon +
      ' production? ' + environment.production +
      ' env: ' + environment.env);

    this.logger.info(' Leia Base Api :' + environment.api_base_url_leia +
    ' Skyhopper Base Api :' + environment.api_base_url_skyhopper +
      ' production? ' + environment.production +
      ' env: ' + environment.env);
  }
}
